import request from '@/utils/request'

const _Prefix = "/performanceStatistics"

// 业绩报表列表-榜单
export function earningTopList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}

//导出业绩报表-榜单
export function earningTopExportList(data) {
    return request({
        url: '/performanceStatistics/export',
        method: 'post',
        params: data
    })
}

// 业绩报表列表
export function earningList(query) {
    return request({
        url: '/comprehensiveStatistics/list',
        method: 'get',
        params: query
    })
}

// 业绩报表列表
export function earningExportList(query) {
    return request({
        url: '/comprehensiveStatistics/export',
        method: 'post',
        params: data
    })
}




